export function gtmGlobal ({ $gtm, $config, locale }) {
	$gtm.init($config.gtm[locale]);
}
